import { render } from "./UiHeadline.vue?vue&type=template&id=1877d0a6&ts=true"
import script from "./UiHeadline.vue?vue&type=script&lang=ts"
export * from "./UiHeadline.vue?vue&type=script&lang=ts"

import exportComponent from "/home/ni/IdeaProjects/pioneer/pioneer-lk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__